import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Events.css";

interface EventData {
  id: string;
  name: string;
  location: string;
  startsOn: string;
  endsOn: string;
  organizationName: string;
  organizationProfilePicture: string;
  imagePath: string;
  theme: string;
}

const Events: FC = () => {
  const [events, setEvents] = useState<EventData[]>([]);
  const [sortedEvents, setSortedEvents] = useState<EventData[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("ascending");
  const [selectedDate, setSelectedDate] = useState<string>("");

  useEffect(() => {
    fetch("https://api.deceit.dev/events")
      .then((res) => res.json())
      .then((data) => {
        setEvents(data);
        setSortedEvents(data);
      });
  }, []);

  useEffect(() => {
    const filteredEvents = events.filter(
      (event) =>
        event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        event.location.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    setSortedEvents(filteredEvents);
  }, [searchQuery, events]);

  useEffect(() => {
    const sorted = [...events].sort((a, b) => {
      const dateA = new Date(a.startsOn).getTime();
      const dateB = new Date(b.startsOn).getTime();
      return sortOrder === "ascending" ? dateA - dateB : dateB - dateA;
    });
    setSortedEvents(sorted);
  }, [sortOrder, events]);
  useEffect(() => {
    if (selectedDate) {
      const filteredEvents = events.filter(
        (event) => new Date(event.startsOn) >= new Date(selectedDate),
      );
      setSortedEvents(filteredEvents);
    } else {
      setSortedEvents(events);
    }
  }, [selectedDate, events]);

  return (
    <div className="Events">
      <h1 className="font-bold text-4xl mb-4">Upcoming Events</h1>

      <div className="mb-6 flex flex-col lg:flex-row gap-4">
        <div className="flex max-sm:flex-col gap-3">
          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className="px-4 py-2 border border-blue-900 bg-blue-950 rounded-sm"
          >
            <option value="ascending">Ascending</option>
            <option value="descending">Descending</option>
          </select>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="px-4 py-2 border border-blue-900 bg-blue-950 rounded-sm"
          />
          <input
            type="text"
            placeholder="Search events..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="px-4 py-2 border border-blue-900 bg-blue-950 rounded-sm flex-grow"
          />
        </div>
      </div>

      <div className="lg:flex gap-3 lg:flex-wrap mb-6 flex-col lg:flex-row">
        {sortedEvents.length === 0 ? (
          <p className="text-gray-300">No events available at the moment.</p>
        ) : (
          sortedEvents.map((event) => (
            <Link key={event.id} to={`/events/${event.id}`}>
              <div className="bg-blue-950 max-lg:min-w-full min-w-72 max-w-72 max-lg:mb-3 rounded-sm overflow-hidden border border-blue-900 hover:border-blue-400 shadow-md hover:shadow-2xl hover:cursor-pointer">
                <img
                  src={`${event.imagePath != null ? "https://se-images.campuslabs.ca/clink/images/" + event.imagePath + "?preset=large-sq" : "https://static.campuslabsengage.com/discovery/images/events/social.jpg"}`}
                  alt="Event"
                  className="w-full h-32 object-cover"
                />

                <div className="p-4">
                  <h2 className="text-xl font-bold text-gray-100 mb-1 truncate">
                    {event.name}
                  </h2>
                  <p className="text-gray-300 text-sm mb-4 truncate">
                    {event.location}
                  </p>
                  <hr className="mb-4 opacity-15" />
                  <div className="flex items-center gap-2 mb-2">
                    <img
                      src={`https://se-images.campuslabs.ca/clink/images/${event.organizationProfilePicture}?preset=small-sq`}
                      alt=""
                      className="rounded-full w-7"
                    />
                    <p className="text-md font-bold text-gray-200 truncate">
                      {event.organizationName}
                    </p>
                  </div>
                  <div className="text-sm text-gray-300 opacity-90 mb-2">
                    <p>
                      Starts{" "}
                      {new Date(event.startsOn).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </p>
                    <p>
                      Until{" "}
                      {new Date(event.endsOn).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </p>
                  </div>
                  <div className="text-xs inline-block bg-green-300 text-slate-950 font-bold px-2 py-1 rounded-sm">
                    {event.theme}
                  </div>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default Events;
